import { c as _c } from "react/compiler-runtime";
import SvgAdd from '@common/__generated__/icon/SvgAdd';
import SvgCheck from '@common/__generated__/icon/SvgCheck';
import SvgDelete from '@common/__generated__/icon/SvgDelete';
import { Button, Spinner } from '@common/components';
import { S3_CDN_TYPE, type S3_PATH_TYPE } from '@common/constants/s3';
import { useToast } from '@common/hooks';
import { cn } from '@core/utils';
import { useMutation } from '@tanstack/react-query';
import { AuthApi } from '@/api';
import { useFileUpload } from '@/hooks/useFileUpload';
import { Image as S3Image } from './Image';
interface PlusBoxProps {
  className?: string;
  onUpload?: (fileUrl?: string) => void;
  onDelete?: () => void;
  limitByte?: number;
  limitPixel?: {
    width: number;
    height: number;
  };
  type: `${S3_PATH_TYPE}`;
  imageUrl?: string;
  accepts?: string;
  s3CdnType?: `${S3_CDN_TYPE}`;
  disabled?: boolean;
  previewBlank?: boolean;
  size?: number;
}
export const FileUploadPlusBox = t0 => {
  const $ = _c(47);
  const {
    className,
    onUpload,
    onDelete,
    limitByte,
    limitPixel,
    type,
    imageUrl,
    accepts: t1,
    s3CdnType: t2,
    disabled,
    previewBlank,
    size: t3
  } = t0;
  const accepts = t1 === undefined ? "image/*" : t1;
  const s3CdnType = t2 === undefined ? "S3_CDN_TYPE_WELFAREHELLO" : t2;
  const size = t3 === undefined ? 72 : t3;
  const {
    toast
  } = useToast();
  let t4;
  if ($[0] !== accepts) {
    t4 = {
      accept: accepts
    };
    $[0] = accepts;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const {
    getFile
  } = useFileUpload(t4);
  let t5;
  if ($[2] !== type) {
    t5 = {
      mutationFn: file => AuthApi["post:/wello/v2/auth/s3"]({
        body: {
          fileUrlList: [file],
          s3CdnTypeCd: "S3_CDN_TYPE_WELFAREHELLO",
          type
        }
      })
    };
    $[2] = type;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const {
    mutateAsync: uploadFileAsyncMutate,
    isPending: isUploading
  } = useMutation(t5);
  const isThumbnailMode = !!imageUrl;
  const isUploadDisabled = isUploading || isThumbnailMode || disabled;
  let t6;
  bb0: {
    if (isUploading) {
      let t7;
      if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = <Spinner size={14} />;
        $[4] = t7;
      } else {
        t7 = $[4];
      }
      t6 = t7;
      break bb0;
    }
    if (!imageUrl) {
      let t7;
      if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = <SvgAdd className="size-20 text-Gray-400" />;
        $[5] = t7;
      } else {
        t7 = $[5];
      }
      t6 = t7;
      break bb0;
    }
    switch (s3CdnType) {
      case S3_CDN_TYPE.WELFARE_HELLO:
        {
          const t7 = previewBlank ? imageUrl : undefined;
          let t8;
          if ($[6] !== previewBlank) {
            t8 = e => {
              if (!previewBlank) {
                e.preventDefault();
              }
            };
            $[6] = previewBlank;
            $[7] = t8;
          } else {
            t8 = $[7];
          }
          let t9;
          if ($[8] !== imageUrl || $[9] !== size) {
            t9 = <S3Image src={imageUrl} alt={"\uC378\uB124\uC77C \uC774\uBBF8\uC9C0"} width={size} height={size} draggable={false} className="size-full select-none rounded-small object-cover object-center" />;
            $[8] = imageUrl;
            $[9] = size;
            $[10] = t9;
          } else {
            t9 = $[10];
          }
          let t10;
          if ($[11] !== t7 || $[12] !== t8 || $[13] !== t9) {
            t10 = <a href={t7} target="_blank" rel="noopener noreferrer external" className="size-full rounded-small" onClick={t8}>{t9}</a>;
            $[11] = t7;
            $[12] = t8;
            $[13] = t9;
            $[14] = t10;
          } else {
            t10 = $[14];
          }
          t6 = t10;
          break bb0;
        }
      case S3_CDN_TYPE.ENCRYPT:
        {
          let t7;
          if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = <SvgCheck className="text-G-200" />;
            $[15] = t7;
          } else {
            t7 = $[15];
          }
          t6 = t7;
          break bb0;
        }
    }
    t6 = undefined;
  }
  const thumbnail = t6;
  let t7;
  if ($[16] !== isUploadDisabled) {
    t7 = cn("size-fit cursor-pointer", {
      "cursor-default": isUploadDisabled
    });
    $[16] = isUploadDisabled;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== className) {
    t8 = cn("relative rounded-small border border-Gray-black/5 bg-Gray-50 transition-all flex-center hover:bg-Gray-50/70", className);
    $[18] = className;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== size) {
    t9 = {
      width: size,
      height: size
    };
    $[20] = size;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t8 || $[23] !== t9 || $[24] !== thumbnail) {
    t10 = <article className={t8} style={t9}>{thumbnail}</article>;
    $[22] = t8;
    $[23] = t9;
    $[24] = thumbnail;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== getFile || $[27] !== limitByte || $[28] !== limitPixel || $[29] !== onUpload || $[30] !== toast || $[31] !== uploadFileAsyncMutate) {
    t11 = async () => {
      const file_0 = await getFile();
      if (!file_0) {
        return;
      }
      if (limitByte && file_0.size > limitByte) {
        toast({
          message: `이미지 용량은 ${limitByte / 1024 / 1024}MB 이하여야 합니다.`,
          type: "warning"
        });
        return;
      }
      if (limitPixel) {
        const reader = new FileReader();
        reader.onload = () => {
          const img = new Image();
          img.onload = () => {
            if (img.width > limitPixel.width || img.height > limitPixel.height) {
              toast({
                message: `이미지 크기는 ${limitPixel.width}x${limitPixel.height} 픽셀 이하여야 합니다.`,
                type: "warning"
              });
              return;
            }
          };
        };
      }
      const {
        data
      } = await uploadFileAsyncMutate(file_0);
      if (!data?.context?.contents?.[0].fileUrl) {
        console.error("\uC774\uBBF8\uC9C0 \uC5C5\uB85C\uB4DC\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4.");
        return;
      }
      onUpload?.(data?.context?.contents?.[0].fileUrl);
    };
    $[26] = getFile;
    $[27] = limitByte;
    $[28] = limitPixel;
    $[29] = onUpload;
    $[30] = toast;
    $[31] = uploadFileAsyncMutate;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== isUploadDisabled || $[34] !== t11) {
    t12 = <input type="button" className="hidden" disabled={isUploadDisabled} onClick={t11} />;
    $[33] = isUploadDisabled;
    $[34] = t11;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[36] !== t10 || $[37] !== t12 || $[38] !== t7) {
    t13 = <label className={t7}>{t10}{t12}</label>;
    $[36] = t10;
    $[37] = t12;
    $[38] = t7;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  let t14;
  if ($[40] !== disabled || $[41] !== isThumbnailMode || $[42] !== onDelete) {
    t14 = isThumbnailMode && !disabled && <Button onClick={e_0 => {
      e_0.stopPropagation();
      onDelete?.();
    }} theme="sub-text" className="absolute right-3 top-3 size-fit -translate-y-1/2 translate-x-1/2 border border-Gray-white bg-Gray-400/90 p-3"><SvgDelete className="size-8 text-Gray-black" /></Button>;
    $[40] = disabled;
    $[41] = isThumbnailMode;
    $[42] = onDelete;
    $[43] = t14;
  } else {
    t14 = $[43];
  }
  let t15;
  if ($[44] !== t13 || $[45] !== t14) {
    t15 = <article className="relative size-fit">{t13}{t14}</article>;
    $[44] = t13;
    $[45] = t14;
    $[46] = t15;
  } else {
    t15 = $[46];
  }
  return t15;
};